module.exports = __webpack_public_path__ + "img/59bc550.jpg";